import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BatchClient } from "../../../../../../Wrap/Api/Orders/Batch";
import { OrdersClient } from "../../../../../../Wrap/Api/Orders/Orders";
import { SwitchOrderClient } from "../../../../../../Wrap/Api/Orders/SwitchOrder";
import { OrderDirection } from "../../../../../../Wrap/Constants/Enums/Domain/OrderDirection";
import { BatchType } from "../../../../../../Wrap/Constants/Enums/Orders/Batch/BatchType";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { SwitchDispatcher } from "../Store/Variable";
import { BatchInfoModel } from "../../../../../../Wrap/Models/Domains/Orders/Batch/BatchInfoModel";
import { CommissionChargeClient } from "../../../../../../Wrap/Api/Charge/CommissionCharge";
import { CommissionCharge } from "../../../../../../Wrap/Models/Models/Charges/CommissionCharge";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";

export class SwitchAction {
    public static checkFBRC(subAccountHierarchyId: string, callback: (result: CommissionCharge) => void) {
        const client = new CommissionChargeClient();
        const promise = client.get(subAccountHierarchyId);

        promise.onSuccess((result) => {
            callback(result);
        });
    }

    public static initSwitchModel() {
        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];
        const initModel = {
            BatchType: BatchType.OneOff,
            OrderType: BatchType.OneOff,
            ActionDate: JsonDateParser.toDateNoOffset(new Date()),
            HierarchyId: subAccountHierarchyId,
            IsSwitch: true,
        };
        SwitchDispatcher.dispatch({ actionType: ActionType.Success, payload: initModel });
    }

    public static goToNextStep(from, data, callback) {
        if (from == 0) {
            return this.getBatchId(data, callback);
        } else if (from == 2) {
            return this.saveSwitch(data, callback);
        }
        callback();
    }

    public static saveSwitch(data, callback) {
        const client = new SwitchOrderClient();
        const _data = JSON.parse(JSON.stringify(data));
        const sellOrder: BatchInfoModel = {
            InvestmentList: data.SellInvestmentList.filter((ele) => ele.OrderValue > 0),
            BuyOrSell: OrderDirection.Sell,
        };
        _data.SellOrder = sellOrder;

        const buyOrder: BatchInfoModel = {
            InvestmentList: data.BuyInvestmentList.filter((ele) => ele.OrderPercentage > 0),
            BuyOrSell: OrderDirection.Buy,
        };
        _data.BuyOrder = buyOrder;
        _data.TransactionId = data.TransId;

        client.post(_data).onSuccess((d) => {
            callback(d);
        });
    }

    public static getBatchId(data, callback) {
        const batchId = getQueryParameters()["batchId"];
        if (batchId) {
            SwitchDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            if (callback) {callback([]);}
            return data;
        }

        let promise;
        const client = new BatchClient();
        promise = client.post(data);
        promise.onSuccess((result) => {
            SwitchDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: {
                    ...result,
                    OrderType: data.OrderType,
                    BuyInvestmentList: data.BuyInvestmentList || [],
                    SellInvestmentList: data.SellInvestmentList || [],
                    TotalValue: data.TotalValue || 0,
                    AdviceGiven: true,
                },
            });

            if (callback) {callback([]);}
        });

        promise.onError((err) => {});
    }

    public static submit(data, callback) {
        const client = new OrdersClient();
        client.post(data).onSuccess((result) => {
            callback(result);
        });
    }
}
